<template>
  <div>
    <PCNavbar selectIndex="5" />
    <MobileNavBar :currentActive="1" />
    <router-view></router-view>
    <CallMe/>
    <MobileCallme/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme
  },
  watch: {
    '$route'(to, from) {
      // to: 新的路由对象
      // from: 旧的路由对象
      console.log('路由变化：', to.path);
      console.log('从：', from.path, '到：', to.path);
      location.reload()
    }
  }
}
</script>

<style>
</style>